import { cn } from '@/lib/utils'

import type { ContentfulSpacing } from '@/lib/contentful-api'
import type { HTMLAttributes, ReactNode } from 'react'

interface SectionType extends ContentfulSpacing, HTMLAttributes<HTMLDivElement> {
  className?: string
  children?: ReactNode
}

const spacingClasses = {
  pt: {
    none: 'pt-0 md:pt-0 lg:pt-0',
    sm: 'pt-6 md:pt-8 lg:pt-12',
    md: 'pt-8 md:pt-8 lg:pt-16',
    lg: 'pt-8 md:pt-16 lg:pt-24',
  },
  pb: {
    none: 'pb-0 md:pb-0 lg:pb-0',
    sm: 'pb-6 md:pb-8 lg:pb-12',
    md: 'pb-8 md:pb-8 lg:pb-16',
    lg: 'pb-8 md:pb-16 lg:pb-24',
  },
} as const

export const CmsContainer = ({ className, children, topPadding = 'lg', bottomPadding = 'lg', ...rest }: SectionType) => {
  return (
    <div className={cn(topPadding && spacingClasses.pt[topPadding], bottomPadding && spacingClasses.pb[bottomPadding], className)} {...rest}>
      {children}
    </div>
  )
}
